/**
 * Created by neo on 14.12.20.
 */
import { makeAutoObservable } from 'mobx';
import { v4 as UUID } from 'uuid';
import { HttpBackend } from '../../Services/Http/HttpBackend';
import { SubscriptionPlan } from './SubscriptionPlan';
import { Gym, createGym } from '../Gym/Gym';
import { logger } from '../../Utils/logger';

// Raw JSON from backend
export type AthleteCoachSubscriptionJson = {
  id: string;
  athleteId: string;
  gymId?: string;
  plan: SubscriptionPlan;
  validFrom: string;
  validUntil?: string;
  cancelDate?: string;
  trial: boolean;
};

// Observable model type (Date transformations)
export type AthleteCoachSubscription = Omit<AthleteCoachSubscriptionJson, 'validFrom' | 'validUntil'> & {
  validFrom: Date;
  validUntil?: Date;
};

// Factory function
export function createAthleteCoachSubscription(json?: Partial<AthleteCoachSubscriptionJson>): AthleteCoachSubscription {
  return makeAutoObservable({
    id: json?.id ?? UUID(),
    athleteId: json?.athleteId ?? '',
    gymId: json?.gymId,
    plan: json?.plan ?? 'free',
    validFrom: json?.validFrom ? new Date(json.validFrom) : new Date(),
    validUntil: json?.validUntil ? new Date(json.validUntil) : undefined,
    cancelDate: json?.cancelDate,
    trial: json?.trial ?? false,
  });
}

export type RequestWithCodeResponse = {
  gym: Gym;
  subscription: AthleteCoachSubscription;
};

// Static API methods
export const AthleteCoachSubscriptionApi = {
  current(): Promise<AthleteCoachSubscription> {
    return HttpBackend.get(`/coach/subscription/current`).then((res) => createAthleteCoachSubscription(res));
  },

  requestTrial(): Promise<AthleteCoachSubscription> {
    return HttpBackend.post(`/coach/subscription/requestTrial`).then((res) => createAthleteCoachSubscription(res));
  },

  requestByCode(code: string): Promise<RequestWithCodeResponse> {
    return HttpBackend.post(`/coach/subscription/requestByCode?code=${code}`).then((res) => ({
      gym: createGym(res.gym),
      subscription: createAthleteCoachSubscription(res.subscription),
    }));
  },

  canTrial(): Promise<boolean> {
    return HttpBackend.get(`/coach/subscription/canTrial`)
      .then(() => true)
      .catch((err) => {
        logger('no can do brother', err);
        if (err.status === 402 || err.response?.status === 402) {
          return false;
        } else {
          throw err;
        }
      });
  },
};
